// extracted by mini-css-extract-plugin
export default {"cardContainer":"YzuDduLH","mobile":"mobile","rubric":"FjvurPg_","overlay":"LtHerx7k","link":"aew52ebl","cardTextContent":"AerFnSce"};